import * as React from 'react';
import classnames from 'classnames';
import { SECTION_NOTIFICATION_DATA_HOOKS } from '../dataHooks';
import { classes } from '../SectionNotification.st.css';
export class SectionNotificationText extends React.Component {
    render() {
        return (React.createElement("div", { className: classnames(classes.text, this.props.className), "data-hook": SECTION_NOTIFICATION_DATA_HOOKS.text }, this.props.children));
    }
}
SectionNotificationText.displayName = 'SectionNotification.Text';
//# sourceMappingURL=SectionNotificationText.js.map